/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Per-(skill, user) aggregated counts
 */
export type SkillBreakdownRow = {
  /**
   * Skill name
   */
  skillName: string;
  /**
   * Use count for this skill/user combination
   */
  useCount: number;
  /**
   * User email address
   */
  userEmail: string;
};

/** @internal */
export const SkillBreakdownRow$inboundSchema: z.ZodMiniType<
  SkillBreakdownRow,
  unknown
> = z.pipe(
  z.object({
    skill_name: z.string(),
    use_count: z.int(),
    user_email: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "skill_name": "skillName",
      "use_count": "useCount",
      "user_email": "userEmail",
    });
  }),
);

export function skillBreakdownRowFromJSON(
  jsonString: string,
): SafeParseResult<SkillBreakdownRow, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillBreakdownRow$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillBreakdownRow' from JSON`,
  );
}
